<div>
  <div>
    <div>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Data Test Type</mat-label>
        <mat-select [formControl]="state.selectedTestTypeFC" data-test="data-test-builder-dropdown">
          <mat-option
            *ngFor="let testType of state.testTypes; trackBy: trackByFn"
            [value]="testType"
            [attr.data-test]="'data-test-builder-dropdown-option-' + testType"
          >
            <y42-data-test-type-with-icon [dataTestType]="testType"></y42-data-test-type-with-icon>
          </mat-option>
          <mat-select-trigger>
            <y42-data-test-type-with-icon
              [dataTestType]="state.selectedTestTypeFC.value"
            ></y42-data-test-type-with-icon>
          </mat-select-trigger>
        </mat-select>
      </mat-form-field>
    </div>

    <div>
      <ng-container [ngSwitch]="state.selectedTestType">
        <y42-schema-test *ngSwitchCase="'schema'"></y42-schema-test>
        <y42-row-drift-test *ngSwitchCase="'num_row_drift'"></y42-row-drift-test>
        <y42-unique-test *ngSwitchCase="'unique'"></y42-unique-test>
        <y42-ref-integrity-test *ngSwitchCase="'referential_integrity'"></y42-ref-integrity-test>
        <y42-low-code-test *ngSwitchCase="'low_code'"></y42-low-code-test>
        <y42-column-test *ngSwitchCase="'column'"></y42-column-test>
      </ng-container>
    </div>

    <div *ngIf="state.testRunResult">
      <y42-data-test-run-error-display [dataTestRunResult]="state.testRunResult"></y42-data-test-run-error-display>
    </div>

    <div #divScrollTo></div>
  </div>
</div>
<ng-template #sideDetailViewFooter>
  <button
    mat-stroked-button
    class="mr-auto"
    (click)="cancelClick()"
    [attr.data-test]="'data-test-builder-button-cancel'"
  >
    Cancel
  </button>
  <button
    mat-stroked-button
    (click)="runTest()"
    [disabled]="state.runButtonDisabled"
    data-test="data-test-builder-button-run"
  >
    <ng-container *ngIf="!state.testRunResultLoading">
      <fa-icon [icon]="['fal', 'play']"></fa-icon>
      Run
    </ng-container>
    <div class="flex justify-center">
      <mat-spinner [diameter]="30" *ngIf="state.testRunResultLoading"></mat-spinner>
    </div>
  </button>
  <button mat-raised-button color="primary" (click)="saveClick()" [attr.data-test]="'data-test-builder-button-save'">
    Save
  </button>
</ng-template>
